module.exports = __webpack_public_path__ + "static/img/content2.293d7a55.png";